export default __webpack_public_path__ + "static/media/image.busseat-lk.36e3ba77.png";